module.exports = __webpack_public_path__ + "media/img.6b1f3c43.png";